module.exports = __webpack_public_path__ + "./images/c8f768d037dd095db7c488ce49bc621c.webp";